import { type UserActivityAction } from '@heidi/schema/ml-scribe';

import { useQueryUser } from './useQueryUser';

/**
 * Server-authoritative count for a `user_activity` bucket on the current user payload.
 */
export function useUserActivityActionCount(action: UserActivityAction) {
  return useQueryUser((user) => {
    const n = user?.user_activity?.[action];
    return typeof n === 'number' ? n : 0;
  });
}
